import { ChangeDetectionStrategy, Component, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatCheckbox } from "@angular/material/checkbox";

@Component({
    selector: "dtm-ui-checkbox-field",
    templateUrl: "./checkbox-field.component.html",
    styleUrls: ["./checkbox-field.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "[class.mat-mdc-checkbox]": "false",
        "[class.mat-mdc-checkbox-checked]": "false",
        "[class.mat-mdc-checkbox-disabled]": "false",
        "[class.mdc-checkbox--disabled]": "false",
        "[class.checkbox-field-checked]": "checked",
        "[class.checkbox-field-disabled]": "disabled",
        "[class.checkbox-field-indeterminate]": "indeterminate",
        "[class.mat-primary]": "false",
        "[class.mat-accent]": "false",
        "[class.mat-warn]": "false",
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxFieldComponent),
            multi: true,
        },
    ],
})
export class CheckboxFieldComponent extends MatCheckbox {}
